<template>
  <div>
    <v-container>
      <date-filter
        v-model="selectedDate"
        @changeDate="onDateChanged"
        :default-filter="'today'"
      ></date-filter>
      <div v-if="loading">
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </div>
      <div>
        <v-layout row wrap>
          <v-flex xs2 v-for="(item, k) in data" :key="k" class="pa-2">
            <v-card class="text-xs-center pa-2" style="border-radius: 10px">
              <div class="pb-2">
                <v-img
                  v-if="item.image_url"
                  aspect-ratio="1"
                  style="border-radius: 10px"
                  :src="item.image_url"
                ></v-img>
                <v-img
                  v-else
                  aspect-ratio="1"
                  style="border-radius: 10px"
                  src="https://www.cameronsbms.co.uk/app/uploads/2017/09/placeholder-human-300x300.jpg"
                ></v-img>
              </div>
              <div>
                <span style="font-weight:bold;" class="primary--text">{{ item.name }}</span>
              </div>
              <div>
                <span class="caption">ในเวลา:</span>
                <span>{{ item.total_reply ? item.total_reply : '0' }}</span>
              </div>
              <div>
                <span class="caption">นอกเวลา:</span>
                <span>{{ item.total_reply_ot ? item.total_reply_ot : '0' }}</span>
              </div>
              <div>
                <span class="caption">จำนวนที่ตอบ(สนใจ):</span>
                <span>{{ item.closetask ? item.closetask : '0' }}</span>
              </div>
              <div>
                <span class="caption">จำนวนที่ตอบ(ลูกค้ายังไม่เคยทัก):</span>
                <span>{{ item.total_reply_new_user ? item.total_reply_new_user : '0' }}</span>
              </div>
              <div>
                <span class="caption">จำนวนที่ตอบหลังการขาย:</span>
                <span>{{ item.total_reply_after_sale ? item.total_reply_after_sale : '0' }}</span>
              </div>
              <div>
                <span class="caption">จำนวนออเดอร์:</span>
                <span>{{ item.orders ? item.orders : '0' }}</span>
              </div>
              <div>
                <span class="caption">เปอร์เซ็นปิดการขาย:</span>
                <span>
                  {{ calculatePercentageDone(item) }}
                </span>
              </div>
              <div>
                <span class="caption">SLA:</span>
                <span>{{ item.sla ? item.sla.toFixed(2) : '-' }}</span>
              </div>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </v-container>
  </div>
</template>

<script>
import DateFilter from './DateFilter.vue'
import api from '@/api'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      data: [],
      loading: false,
      selectedDate: {
        start: dayjs().format('YYYY-MM-DD 00:00'),
        end: dayjs().format('YYYY-MM-DD 23:59')
      }
    }
  },
  components: {
    DateFilter
  },
  mounted() {
    this.getConversationRate()
  },
  methods: {
    onDateChanged() {
      this.getConversationRate()
    },
    getConversationRate() {
      this.loading = true
      api.getastonconversationrateperadmin(
        { datefrom: this.selectedDate.start, dateto: this.selectedDate.end },
        (err, response) => {
          this.loading = false
          if (response.responsecode == 200) {
            this.data = response.data
          }
        }
      )
    },
    calculatePercentageDone(item) {
      const totalOrder = parseFloat(item.orders || 0) || 0
      const totalReplyAndClose = parseFloat(item.closetask || 0) + parseFloat(item.total_reply_new_user || 0)
      if (totalReplyAndClose === 0) return `0.00%`
      return `${((totalOrder / totalReplyAndClose) * 100).toFixed(2)}%`
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/AstonConversationRate.vue